import {
  FETCH_UPGRADES,
  FETCH_UPGRADES_FAIL,
  FETCH_LOADING
} from '../actions/types';
import update from 'immutability-helper';

const fetchInitialState = {
  isFetching: false,
  data: []
}

export function FetchUpgrades(state = fetchInitialState, action) {
  switch (action.type) {
    case FETCH_UPGRADES:

      return update(state, {
        isFetching: {
          $set: false
        },
        data: {
          $set: action.payload.data === undefined ? [] : action.payload.data
        }
      });

    case FETCH_LOADING:
      return update(state, {
        isFetching: {
          $set: action.payload
        },
        data:{
          $set:[]
        }
      });


    case FETCH_UPGRADES_FAIL:
      return [];
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_upgrades.js